export const GET_TICKETS = 'GET_TICKETS';

export const SUCCESS_IS_CONNECTED = 'SUCCESS_IS_CONNECTED';
export const FAILED_IS_CONNECTED = 'FAILED_IS_CONNECTED';

export const SUCCESS_GET_TICKETS = 'SUCCESS_GET_TICKETS';
export const FAILED_GET_TICKETS = 'FAILED_GET_TICKETS';

export const SUCCESS_CREATE_TICKET = 'SUCCESS_CREATE_TICKET';
export const FAILED_CREATE_TICKET = 'FAILED_CREATE_TICKET';

export const SUCCESS_ADD_COMMENT = 'SUCCESS_ADD_COMMENT';
export const FAILED_ADD_COMMENT = 'FAILED_ADD_COMMENT';

export const SUCCESS_GET_CLIENT_NOTIFY_HISTORIES = 'SUCCESS_GET_CLIENT_NOTIFY_HISTORIES';
export const FAILED_GET_CLIENT_NOTIFY_HISTORIES = 'FAILED_GET_CLIENT_NOTIFY_HISTORIES';

export const GET_OPENED_TICKET_COUNT_SUCCESS = 'GET_OPENED_TICKET_COUNT_SUCCESS';
export const GET_OPENED_TICKET_COUNT_FAILED = 'GET_OPENED_TICKET_COUNT_FAILED';

export const GET_NOTIFICATION_COUNT_SUCCESS = 'GET_NOTIFICATION_COUNT_SUCCESS';
export const GET_NOTIFICATION_COUNT_FAILED = 'GET_NOTIFICATION_COUNT_FAILED';

export const GET_NOTIFICATIONS = 'GET_NOTIFICATIONS';
export const GET_NOTIFICATIONS_SUCCESS = 'GET_NOTIFICATIONS_SUCCESS';
export const GET_NOTIFICATIONS_FAILED = 'GET_NOTIFICATIONS_FAILED';

export const MARK_NOTIFICATION_AS_READ = 'MARK_NOTIFICATION_AS_READ';
export const MARK_NOTIFICATION_AS_READ_SUCCESS = 'MARK_NOTIFICATION_AS_READ_SUCCESS';
export const MARK_NOTIFICATION_AS_READ_FAILED = 'MARK_NOTIFICATION_AS_READ_FAILED';

export const MARK_ALL_NOTIFICATIONS_AS_READ = 'MARK_ALL_NOTIFICATIONS_AS_READ';
export const MARK_ALL_NOTIFICATIONS_AS_READ_SUCCESS = 'MARK_ALL_NOTIFICATIONS_AS_READ_SUCCESS';
export const MARK_ALL_NOTIFICATIONS_AS_READ_FAILED = 'MARK_ALL_NOTIFICATIONS_AS_READ_FAILED';

export const CLEAR_ALL_READ_NOTIFICATIONS = 'CLEAR_ALL_READ_NOTIFICATIONS';
export const CLEAR_ALL_READ_NOTIFICATIONS_SUCCESS = 'CLEAR_ALL_READ_NOTIFICATIONS_SUCCESS';
export const CLEAR_ALL_READ_NOTIFICATIONS_FAILED = 'CLEAR_ALL_READ_NOTIFICATIONS_FAILED';

export const OPEN_NOTIFICATIONS_SLIDER = 'OPEN_NOTIFICATIONS_SLIDER';
export const CLOSE_NOTIFICATIONS_SLIDER = 'CLOSE_NOTIFICATIONS_SLIDER';

export const REMOVE_TICKET_CC_SUCCESS = 'REMOVE_TICKET_CC_SUCCESS';
export const REMOVE_TICKET_CC_FAILED = 'REMOVE_TICKET_CC_FAILED';



// WEBPACK FOOTER //
// ./src/state/constants/zendeskConstants.js